// Pre-carga del día: dispara en segundo plano las consultas que el técnico va a necesitar
// sin conexión. El Service Worker guarda cada respuesta GET, así las pantallas funcionan offline.
import {
  getOrdenes, getOrden, getPlanillaDraft, getServiciosRechazados, getAsistenciaHoy, getEmpresaGeo,
  getServicios, getClientesCompleto, getUsers, getProductos, getNumeroVisita, getLocal,
} from '../services/api';
import { puede } from './permisos';
import { cargarCatalogoRecos } from './recomendaciones';

const today = () => new Date().toISOString().slice(0, 10);
const diasAtras = (n) => { const d = new Date(); d.setDate(d.getDate() - n); return d.toISOString().slice(0, 10); };
const silencio = (p) => p.catch(() => null);

let ultimaPrecarga = 0;

// forzar=true: se usa al marcar la ENTRADA del día (ignora el intervalo mínimo).
export const precargarDatosOffline = async (user, { forzar = false } = {}) => {
  if (!user || !navigator.onLine) return null;
  if (!['tecnico', 'supervisor', 'supervisor_regional'].includes(user.rol)) return null;
  if (!forzar && Date.now() - ultimaPrecarga < 10 * 60 * 1000) return null;
  ultimaPrecarga = Date.now();
  try {
    const veOrdenes = ['programacion', 'mis_servicios', 'planilla_tecnica'].some((m) => puede(user, m));
    const veRechazados = puede(user, 'aprobaciones') || puede(user, 'mis_servicios');
    const [ordenes] = await Promise.all([
      veOrdenes ? silencio(getOrdenes({ mias: true, fecha_desde: today() })) : null,
      veRechazados ? silencio(getServiciosRechazados()) : null,
      silencio(getAsistenciaHoy()),
      silencio(getEmpresaGeo()),
      silencio(getServicios({ tecnico_id: user.id, fecha_desde: diasAtras(60) })),
      silencio(getClientesCompleto()),
      silencio(getUsers()),
      silencio(getProductos({ categoria: 'quimico_insectos', activo: true })),
      silencio(getProductos({ categoria: 'desratizacion', activo: true })),
      cargarCatalogoRecos(),
    ]);
    const lista = (ordenes?.data || []).filter((o) => !['FINALIZADO', 'APROBADO', 'CANCELADO'].includes(o.estado));
    for (const o of lista.slice(0, 30)) {
      await Promise.all([
        silencio(getOrden(o.id)),
        silencio(getPlanillaDraft(o.id)),
        o.local_id ? silencio(getLocal(o.local_id)) : Promise.resolve(),
        o.local_id ? silencio(getNumeroVisita(o.local_id, today())) : Promise.resolve(),
        o.local_id && o.fecha_programada && o.fecha_programada !== today()
          ? silencio(getNumeroVisita(o.local_id, o.fecha_programada)) : Promise.resolve(),
      ]);
    }
    console.info(`[offline] Pre-carga lista: ${lista.length} servicio(s) del día disponibles sin conexión`);
    return lista.length;
  } catch { return null; }
};
